import {createAction} from 'typesafe-actions';
import {Ref as DiscussionCommentRef, DiscussionComment} from './types';

export const updateDiscussionComment = createAction(
  '@discussionComment/updateDiscussionComment',
  action => (ref: DiscussionCommentRef, updatedComment: DiscussionComment) =>
    action({ref, updatedComment})
);
